<template>
  <div>
    <StatusBar :status="status"></StatusBar>
    <div class="photo">
      <div class="font">
        <img class="sfz1" :src="sfz1.data" @click="imageControl(sfz1.type)" alt />
        <p :class="sfz1.uploaded?'hide':'show'">请拍摄本人身份证正面</p>
        <p class="pointText" :class="sfz1.reTake?'show':'hide'" @click="reTakeAction(sfz1.type)">重拍</p>
      </div>
      <div class="back">
        <img class="sfz2" :src="sfz2.data" @click="imageControl(sfz2.type)" alt />
        <p :class="sfz2.uploaded?'hide':'show'">请拍摄本人身份证反面</p>
        <p class="pointText" :class="sfz2.reTake?'show':'hide'" @click.stop="reTakeAction(sfz2.type)">重拍</p>
      </div>
    </div>
    <div class="tsBtnBg" @click="tsControl(true)">
      <span class="tsIcon"></span>
      <span class="tsBtn">点击查看示例</span>
    </div>
    <div class="tsBg" v-if="tsShow">
      <div class="tsContent">
        <p>身份证正面</p>
        <img src="../../assets/tsid1.png" alt="">
        <p>身份证反面</p>
        <img src="../../assets/tsid2.png" alt="">
      </div>
      <img class="closeBtn" src="../../assets/ts_close.png" alt="" @click="tsControl(false)">
    </div>
    <p class="btn" :class="classObject" @click="nextBtnClick">下一步</p>

    <div>
      <div class="title">
        <img src="../../assets/info_left.png" alt />
        <p>拍摄示意图</p>
        <img src="../../assets/info_right.png" alt />
      </div>
      <div class="content">
        <div>
          <span>标准</span>
          <img src="../../assets/id_1standard.png" alt />
        </div>
        <div>
          <span>缺角</span>
          <img src="../../assets/id_2loss.png" alt />
        </div>
        <div>
          <span>模糊</span>
          <img src="../../assets/id_3blur.png" alt />
        </div>
        <div>
          <span>反光</span>
          <img src="../../assets/id_4reflect.png" alt />
        </div>
      </div>
    </div>

    <div class="info-container" v-if="defaultInfo.phone||defaultInfo.address">
      <div v-if="defaultInfo.phone">如有疑问请联系当地分公司：<span>{{ defaultInfo.phone}}</span></div>
      <div v-if="defaultInfo.address">联系地址：{{ defaultInfo.address }}</div>
    </div>
    <div class="info-container"  v-else>
      <div class="tips">
          {{defaultInfo.default_text}}<span>{{defaultInfo.default}}</span>
        </div>
    </div>
  </div>
</template>

<script>
import StatusBar from '../../components/StatusBar'
import {uploadPic, wxConfig, checkCard, submitIdCard, getCompanyInfo} from '../../utils/actions'
import {changeHistory} from '../../utils/common'
import wx from 'weixin-js-sdk'
const IDFRONT = require('../../assets/id_front.png')
const IDBACK = require('../../assets/id_back.png')
const CARFONT = require('../../assets/car_front.png')
const CARBACK = require('../../assets/car_back.png')
export default {
  name: 'cardIDUpLoad',
  components: {
    StatusBar
  },
  data () {
    return {
      status: '',
      sfz1: {
        type: 3,
        uploaded: false,
        reTake: false,
        data: IDFRONT
      },
      sfz2: {
        type: 4,
        uploaded: false,
        reTake: false,
        data: IDBACK
      },
      jsz1: {
        type: 1,
        uploaded: false,
        reTake: false,
        data: CARFONT
      },
      jsz2: {
        type: 2,
        uploaded: false,
        reTake: false,
        data: CARBACK
      },
      unLoadTap: false,
      tsShow: false,
      idCard: '',
      defaultInfo: {}
    }
  },
  created () {
    this.status = this.$route.params.status
    var obj = {
      shareUrl: location.href.split('#')[0].replace('&', '%26').replace('&', '%26').replace('&', '%26')
    }
    // 转一下&
    obj.shareUrl = obj.shareUrl.replace('&', '%26')
    wxConfig(obj).then(function (config) {
      var data = config.data
      data.jsApiList = [
        'checkJsApi', 'onMenuShareTimeline', 'onMenuShareAppMessage', 'hideMenuItems', 'showMenuItems', 'hideAllNonBaseMenuItem', 'showAllNonBaseMenuItem', 'translateVoice', 'startRecord', 'stopRecord', 'onRecordEnd', 'playVoice', 'pauseVoice', 'stopVoice', 'uploadVoice', 'downloadVoice', 'chooseImage', 'previewImage', 'uploadImage', 'downloadImage', 'getNetworkType', 'getLocalImgData', 'openLocation', 'getLocation', 'hideOptionMenu', 'showOptionMenu', 'closeWindow', 'scanQRCode', 'chooseWXPay', 'openProductSpecificView', 'addCard', 'chooseCard', 'openCard'
      ]
      wx.config(data)
    })
    getCompanyInfo({
      city_id: this.$store.state.cityId
    }).then((res) => {
      this.defaultInfo = res.data
    })
    changeHistory()
  },
  methods: {
    nextBtnClick () {
      var that = this
      if (!that.sfz1.uploaded || !that.sfz2.uploaded) {
        return
      }
      checkCard({
        method: 'driver.signup.checkidcard',
        id: that.$store.state.id
      }).then(function (res) {
        if (res && res.code === 0) {
          that.$router.push({name: 'licenceLoad', params: {status: '6'}})
        } else {
          that.clearImage(that.sfz1.type)
          that.clearImage(that.sfz2.type)
        }
      })
    },
    imageControl (type) {
      var info = type === this.sfz1.type ? this.sfz1 : this.sfz2
      if (info.uploaded) {
        wx.previewImage({
          current: info.data,
          urls: [info.data]
        })
      } else {
        this.chooseImage(type)
      }
    },
    reTakeAction (type) {
      // this.clearImage(type)
      this.chooseImage(type)
    },
    clearImage (type) {
      if (type === this.sfz1.type) {
        this.sfz1.data = IDFRONT
        this.sfz1.uploaded = false
        this.sfz1.reTake = false
      } else {
        this.sfz2.data = IDBACK
        this.sfz2.uploaded = false
        this.sfz2.reTake = false
      }
    },
    chooseImage (type) {
      var that = this
      if (that.unLoadTap) {
        return
      }
      wx.chooseImage({
        count: 1,
        sizeType: ['compressed'],
        sourceType: ['camera'],
        success: function (res) {
          that.unLoadTap = true
          wx.uploadImage({
            localId: res.localIds[0],
            isShowProgressTips: 1,
            success: function (res) {
              that.uploadPic(res.serverId, type)
            }
          })
        }
      })
    },
    uploadPic (data, type, callBack) {
      var typeStr = [
        'pic1_base64',
        'pic2_base64',
        'pic3_base64',
        'pic4_base64'
      ]
      var param = {
        imagename: 'myImage.png',
        city_id: this.$store.state.cityId,
        id: this.$store.state.id,
        method: 'driver.signup.upload'
      }
      param[typeStr[type - 1]] = data
      var that = this
      uploadPic(param).then(async function (res) {
        that.unLoadTap = false
        var info = type === that.sfz1.type ? that.sfz1 : that.sfz2
        if (res.code === 0) {
          info.reTake = true
          info.uploaded = true
          info.data = res.pic
          if (res.data.id_card) {
            await that.submitIdCard(res.data.id_card, res.data.id)
          }
        }
        alert(res.message)
      })
    },
    submitIdCard (idCard, id) {
      return submitIdCard({
        idCard,
        recordId: id
      })
    },
    tsControl (val) {
      this.tsShow = val
    }
  },
  computed: {
    classObject () {
      if (this.sfz1.uploaded && this.sfz2.uploaded) {
        return 'opactiy'
      }
      return ''
    }
  }
}
</script>

<style lang="scss" scoped>
.photo {
  text-align: center;
  div {
    position: relative;
    margin: 0 auto;
  }
  img,
  input,
  div {
    width: 3.8rem;
    height: 2.12rem;
  }
  input {
    position: absolute;
    left: 0;
    top: 0;
    opacity: 0;
  }
  p{
    position: absolute;
    font-size: 0.24rem;
    color: #19191A;
    width: 100%;
    text-align: center;
  }
  .pointText{
    color: white;
    bottom: 0;
    opacity: 0.5;
    height: 0.48rem;
    line-height: 0.48rem;
    background: #000000;
  }
  .font {
    margin-top: 0.76rem;
    p:nth-of-type(1){
      top: 1.28rem;
    }
  }
  .back {
    margin-top: 0.3rem;
    p:nth-of-type(1){
      top: 1.2rem;
    }
  }
}
.btn {
  height: 0.92rem;
  width: 90%;
  margin-left: 5%;
  margin-top: 0.42rem;
  line-height: 0.92rem;
  text-align: center;
  opacity: 0.3;
  color: #ffffff;
  font-size: 0.3rem;
  border-radius: 0.04rem;
  background-image: linear-gradient(269deg, #3b414d 0%, #262a32 100%);
}
.tsBtnBg{
  text-align: center;
  font-size: 0.24rem;
  margin-top: 0.42rem;
  margin-bottom: 0.46rem;
  .tsIcon{
    position: absolute;
    top: 6.72rem;
    left: 2.5rem;
    background: url('../../assets/bar_icon_info.png') no-repeat;
    background-size: 100%;
    width: 0.3rem;
    height: 0.3rem;
  }
  .tsBtn{
    color: #737780;
    line-height: 0.25rem;
    border-bottom: 1px solid #737780;
  }
}
.tsBg{
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: rgba($color: #000000, $alpha: 0.6);
  z-index: 1;
  text-align: center;
  .tsContent{
    margin: 0 auto;
    margin-top: 1.22rem;
    width: 5.6rem;
    height: 8.52rem;
    background: #FFFFFF;
    box-shadow: 0 0 10px 0 rgba(0,0,0,0.20);
    border-radius: 0.12rem;
    overflow: hidden;
    p{
      font-size: 0.24rem;
      color: #19191A;
      margin-top: 0.26rem;
      margin-bottom: 0.1rem;
    }
    img{
      width: 5.2rem;
      height: 3.28rem;
    }
  }
  .closeBtn{
    width: 0.6rem;
    height: 0.6rem;
  }
}
.opactiy {
  opacity: 1 !important;
}

.title {
  text-align: center;
  margin-top: -0.3rem;
  img,
  p {
    display: inline-block;
  }
  img {
    width: 0.98rem;
    height: 0.12rem;
    vertical-align: 0.04rem;
  }
  p {
    font-size: 0.28rem;
    color: #323233;
    line-height: 0.24rem;
  }
}
.content {
  width: 94%;
  margin-left: 3%;
  display: flex;
  text-align: center;
  margin-top: -0.5rem;
  margin-bottom: 2rem;
  div {
    flex: 1;
  }
  span {
    font-size: 0.24rem;
    color: #646566;
  }
  img {
    margin-top: 0.2rem;
    width: 1.6rem;
    height: 1rem;
  }
}

.info-container {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  width: 95%;
  margin: 0 auto;
  text-align: center;
  color: #19191A;
  line-height: .34rem;
  font-size: .24rem;
  background-color: #fff;
  padding: .44rem 0;
  box-sizing: border-box;
  div {
    span {
      color: #2A2AFF;
    }
  }
}
.tips {
  text-align: center;
  font-size: .24rem;
  font-weight: 400;
  color: #19191A;
  line-height: .34rem;
  span {
    color: #2A2AFF;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/carID-uploading/index.vue